/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentStateWithheldPlugin,
  AgentStateWithheldPlugin$Outbound,
  AgentStateWithheldPlugin$outboundSchema,
} from "./agentstatewithheldplugin.js";

/**
 * The policy the agent's last reconcile applied.
 */
export type AgentStatePolicy = {
  /**
   * When the agent first applied this etag. Later reconciles of the same etag keep this time.
   */
  appliedAt?: Date | undefined;
  /**
   * Etag of the getPlugins snapshot the last reconcile applied. Omitted before the agent has applied one.
   */
  appliedEtag?: string | undefined;
  /**
   * Etag of the remote configuration the agent applied.
   */
  remoteConfigEtag?: string | undefined;
  /**
   * True when the agent could not apply the remote configuration it last received and kept its previous settings.
   */
  remoteConfigFailed?: boolean | undefined;
  /**
   * Optional plugins the agent left out of the applied set because of a user choice. Required plugins are never withheld.
   */
  withheldPlugins: Array<AgentStateWithheldPlugin>;
};

/** @internal */
export type AgentStatePolicy$Outbound = {
  applied_at?: string | undefined;
  applied_etag?: string | undefined;
  remote_config_etag?: string | undefined;
  remote_config_failed?: boolean | undefined;
  withheld_plugins: Array<AgentStateWithheldPlugin$Outbound>;
};

/** @internal */
export const AgentStatePolicy$outboundSchema: z.ZodMiniType<
  AgentStatePolicy$Outbound,
  AgentStatePolicy
> = z.pipe(
  z.object({
    appliedAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    appliedEtag: z.optional(z.string()),
    remoteConfigEtag: z.optional(z.string()),
    remoteConfigFailed: z.optional(z.boolean()),
    withheldPlugins: z.array(AgentStateWithheldPlugin$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      appliedAt: "applied_at",
      appliedEtag: "applied_etag",
      remoteConfigEtag: "remote_config_etag",
      remoteConfigFailed: "remote_config_failed",
      withheldPlugins: "withheld_plugins",
    });
  }),
);

export function agentStatePolicyToJSON(
  agentStatePolicy: AgentStatePolicy,
): string {
  return JSON.stringify(
    AgentStatePolicy$outboundSchema.parse(agentStatePolicy),
  );
}
